import { FINANCE } from 'consts';

export const STATUS_DELETED = -1;
export const STATUS_DRAFT = 0; //skip
export const STATUS_PROCESSING = 1;
export const STATUS_APPROVED = 2;
export const STATUS_REJECTED = 3;
export const STATUS_ERROR = 4;
export const STATUS_PENDING_SENIOR_TL = 5;
export const STATUS_PENDING_BC = 6;
export const STATUS_PENDING_VP = 7;
export const STATUS_PAID = 8;
export const STATUS_MORE_INFO = 9;
export const STATUS_INVOICED = 10;
export const STATUS_PARTIALLY_PAID = 11;
export const STATUS_PENDING_IO = 12;
export const STATUS_EXTERNAL_REJECTED = 13;
export const STATUS_PENDING_SA = 14;
export const STATUS_PENDING_TL = 15;

export const STATUS_COLOR_MAP = new Map([
  [STATUS_DELETED, 'inactive'],
  [STATUS_DRAFT, 'processing'],
  [STATUS_PROCESSING, 'processing'],
  [STATUS_APPROVED, 'success'],
  [STATUS_REJECTED, 'danger'],
  [STATUS_ERROR, 'danger'],
  [STATUS_PENDING_SENIOR_TL, 'processing'],
  [STATUS_PENDING_BC, 'processing'],
  [STATUS_PENDING_VP, 'processing'],
  [STATUS_PAID, 'completed'],
  [STATUS_MORE_INFO, 'info'],
  [STATUS_INVOICED, 'info'],
  [STATUS_PARTIALLY_PAID, 'completed'],
  [STATUS_PENDING_IO, 'processing'],
  [STATUS_EXTERNAL_REJECTED, 'warning'],
  [STATUS_PENDING_SA, 'processing'],
  [STATUS_PENDING_TL, 'processing'],
]);
export const IMPORTANCE_NORMAL = 0;
export const IMPORTANCE_URGENT = 1;
export const IMPORTANCE_COLOR_MAP = new Map([
  [IMPORTANCE_NORMAL, 'dark'],
  [IMPORTANCE_URGENT, 'warning-shade'],
]);
export const INVOICE_STATUS_NEW = 0;
export const INVOICE_STATUS_PAID = 1;
export const INVOICE_STATUS_CANCELED = 2;
export const INVOICE_STATUS_DELETED = 3;
export const INVOICE_STATUS_REJECTED = 4;
export const INVOICE_STATUS_APPROVED = 5;
export const INVOICE_STATUS_DRAFT = 6;
export const INVOICE_STATUS_COLOR_MAP = new Map([
  [INVOICE_STATUS_NEW, 'success'],
  [INVOICE_STATUS_PAID, 'completed'],
  [INVOICE_STATUS_CANCELED, 'info'],
  [INVOICE_STATUS_DELETED, 'inactive'],
  [INVOICE_STATUS_REJECTED, 'info'],
  [INVOICE_STATUS_APPROVED, 'completed'],
  [INVOICE_STATUS_DRAFT, 'processing'],
]);

export const TAB_DETAILS = 'details';
export const TAB_INVOICES = 'invoices';
export const TAB_ACTIONS_LOG = 'actions-log';

export const getRoute = (id: number) => {
  return `/${FINANCE}/fr/${id}/${TAB_DETAILS}`;
};

export const ACTION_APPROVE = 'Approve';
export const ACTION_REJECT = 'Reject';
export const ACTION_MORE_INFO = 'MoreInfo';
export const ACTION_UNDO = 'Undo';
